import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'lib-flexible/flexible'
import 'video.js/dist/video-js.css'
import * as filters from './filters' // global filters 管道 https://cn.vuejs.org/v2/guide/filters.html#ad
import {
    NoticeBar,
    Badge,
    Rate,
    Switch,
    Empty,
    Picker,
    Form,
    Calendar,
    Checkbox,
    CheckboxGroup,
    CountDown,
    Search,
    Loading,
    RadioGroup,
    Radio,
    Dialog,
    Cascader,
    Tabbar,
    TabbarItem,
    DropdownMenu,
    DropdownItem,
    Field,
    ActionSheet,
    Tab,
    Tabs,
    Progress,
    Collapse,
    CollapseItem,
    Overlay,
    Swipe,
    SwipeItem,
    Uploader,
    Button,
    List,
    Cell,
    CellGroup,
    PullRefresh,
    Skeleton,
    Panel,
    Tag,
    Col,
    Row,
    Image,
    Lazyload,
    Icon,
    ImagePreview,
    Divider,
    Sticky,
    Notify,
    Toast,
    Popup,
    IndexBar,
    IndexAnchor,
    DatetimePicker,
} from 'vant'
import VueVideoPlayer from 'vue-video-player'
import setting from './constant/setting'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import getPageTitle from '@/utils/get-page-title'
import { localUserInfo } from '@/utils/user'
import { kbBridge } from '@/utils/_kb-bridge'
import LuckDraw from 'vue-luck-draw'
import carPlateKeyboard from 'car-plate-keyboard'
import 'car-plate-keyboard/lib/carPlateKeyboard.css'

Vue.use(carPlateKeyboard)
Vue.use(LuckDraw)
//视频
Vue.use(
    VueVideoPlayer /* {
  options: global default options,
  events: global videojs events
} */,
)
const hls = require('videojs-contrib-hls')
Vue.use(hls)

// const amapKeys = Object.keys(localStorage).filter(key => key.match(/^_AMap_/))
// amapKeys.forEach(key => {
//   localStorage.removeItem(key);
// })
import { isKbApp } from './hooks/use-env'

Vue.prototype.$bridge = kbBridge

// register global utility filters
Object.keys(filters).forEach((key) => {
    Vue.filter(key, filters[key])
})

Vue.use(NoticeBar)
Vue.use(Badge)
Vue.use(Rate)
Vue.use(Switch)
Vue.use(Empty)
Vue.use(Picker)
Vue.use(Form)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Calendar)
Vue.use(CountDown)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Dialog)
Vue.use(Cascader)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Field)
Vue.use(ActionSheet)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Progress)
Vue.use(Skeleton)
Vue.use(List)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Panel)
Vue.use(Button)
Vue.use(PullRefresh)
Vue.use(Tag)
Vue.use(Col)
Vue.use(Row)
Vue.use(Image)
Vue.use(Lazyload)
Vue.use(Icon)
Vue.use(ImagePreview)
Vue.use(Divider)
Vue.use(Sticky)
Vue.use(Notify)
Vue.use(Toast)
Vue.use(Overlay)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Uploader)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Loading)
Vue.use(Popup)
Vue.use(Search)
Vue.use(IndexBar)
Vue.use(IndexAnchor)
Vue.use(DatetimePicker)

Vue.config.productionTip = false
Vue.prototype.$setting = setting
Vue.prototype.Notify = Notify
Vue.prototype.Toast = Toast
Vue.prototype.ImagePreview = ImagePreview
Vue.config.ignoredElements = ['wx-open-launch-app', 'wx-open-launch-weapp']

let vm = new Vue({
    router,
    store,
    render: (h) => h(App),
    created() {},
    mounted() {
        // @ts-ignore
        window.vue = this
    },
}).$mount('#app')

NProgress.configure({ showSpinner: false }) // NProgress Configuration
router.beforeEach(async (to, from, next) => {
    if (isKbApp) {
        //获取客户端信息
        localUserInfo(vm)
    }
    NProgress.start()
    if (to.meta.title) {
        document.title = getPageTitle(to.meta.title)
    }
    next()
    NProgress.done()
})
router.afterEach(() => {
    NProgress.done()
})
